import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import McuImsSvc from "@/services/McuIms";
import type { McuImsInterface, McuMastersInterface } from "@/types/mcu_ims";

const EMPTY_MASTERS: McuMastersInterface = {
  paket: [],
  pekerjaan_shift: [],
  fitness: [],
  rekomendasi_tl: [],
  pajanan: [],
  icd10_z_umum: []
};

@Module({ store, dynamic: true, namespaced: true, name: "mcu-ims" })
class McuImsModule extends VuexModule {
  items: McuImsInterface[] = [];
  currentItem: McuImsInterface | null = null;
  loading = false;
  masters: McuMastersInterface = { ...EMPTY_MASTERS };
  mastersLoaded = false;

  @Mutation SET_ITEMS(val: McuImsInterface[]) {
    this.items = val;
  }
  @Mutation SET_CURRENT_ITEM(val: McuImsInterface | null) {
    this.currentItem = val;
  }
  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }
  @Mutation SET_MASTERS(val: McuMastersInterface) {
    this.masters = val;
    this.mastersLoaded = true;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);
    try {
      const dt = await McuImsSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_ITEMS(data || []);
    } catch {
      this.SET_ITEMS([]);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await McuImsSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadMasters() {
    if (this.mastersLoaded && this.masters.paket.length > 0) return;
    try {
      const dt = await McuImsSvc.getMasters();
      this.SET_MASTERS(dt.data.data || { ...EMPTY_MASTERS });
    } catch {
      this.SET_MASTERS({ ...EMPTY_MASTERS });
    }
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
  }
}

export const storeMcuIms = getModule(McuImsModule);
